import { ANALYTIC_DETAIL_MODE } from '@common/constant/fab';
import {
  ANALYTIC_INDEPTH_MODE,
  ANALYTIC_LIST_MODE,
  FILTER_PICKER_MODE,
} from '@common/constant/mode';
import {
  COMPANY_OPTION_KEY,
  FILTER_OPTION_CONFIG,
  LAYOUT_OPTION_KEY,
} from '@common/constant/option';

export function isListMode(mode) {
  return mode === ANALYTIC_LIST_MODE;
}

export function isDepthMode(mode) {
  return mode === ANALYTIC_INDEPTH_MODE;
}

export function isMonthPickerMode(mode) {
  return mode === FILTER_PICKER_MODE;
}

export const getFilterConfigForComponent = (componentType) => {
  switch (componentType) {
    case ANALYTIC_DETAIL_MODE:
      return FILTER_OPTION_CONFIG.filter(
        (item) =>
          item.key === LAYOUT_OPTION_KEY || item.key === COMPANY_OPTION_KEY,
      );
    case ANALYTIC_LIST_MODE:
      return FILTER_OPTION_CONFIG;
    default:
      return FILTER_OPTION_CONFIG;
  }
};
